export class CreditCardEditRequest {

    CreditCardID: number;
    ExpMonth: number;
    ExpYear: number;
    FirstName: string;
    LastName: string;
    Zipcode: string;

}
